<template>
  <div class="container">
    <h2 class="room-h2 txt-center">Room</h2>
    <h3 class="room-h3 txt-center">当旅館のお部屋</h3>
    <p class="room-p txt-center">当旅館のお部屋の一部をご紹介</p>
    <p class="room-p txt-center">
      <small
        >※当館は全室、空調設備完備・光触媒コーティングによる抗菌にて
        感染症対策を行っております。</small
      >
    </p>

    <div class="room-item wa">
      <div class="bgimg-opc">
        <h3 class="room-title txt-center">和室の間</h3>
        <div class="room-imgs">
          <img
            class="room-img"
            src="@/assets/img/sample2/room/room-wa1.jpg"
            alt="和室１"
          />
          <img
            class="room-img"
            src="@/assets/img/sample2/room/room-wa2.jpg"
            alt="和室２"
          />
          <img
            class="room-img"
            src="@/assets/img/sample2/room/room-wa3.jpg"
            alt="和室３"
          />
        </div>
        
        
        <p class="room-item-p">
          和室の間では、実家のようにくつろげる空間をご提供。<br />
          和室の良さを現代の技術を組合わせて快適に過ごしていただけるお部屋になっております。<br />
          冬には嬉しいコタツも利用可能です。
        </p>
        <p class="room-item-p">
          定員<br />
          ２～４名様
        </p>
        <p class="room-item-p">料金<br>
        お一人様：16,000～</p>
        <p class="room-item-p">
          設備等<br />
          テレビ／冷蔵庫／冷暖房／床暖房／空気清浄機／お風呂／洗面台／トイレ
        </p>
      </div>
    </div>

    <div class="room-item yo">
      <div class="bgimg-opc">
        <h3 class="room-title txt-center">洋室の間</h3>
        <div class="room-imgs-y">
          <img
            class="room-img-y"
            src="@/assets/img/sample2/room/room-y1.jpg"
            alt="洋室１"
          />
          <img
            class="room-img-y"
            src="@/assets/img/sample2/room/room-y2.jpg"
            alt="洋室２"
          />
        </div>
        
        <p class="room-item-p">
          洋室の間では、雰囲気がガラリと変わってホテルのようなお部屋になっております。<br />
          ツインベッドルーム・ダブルベッドルームをご用意しております。<br />こちらのお部屋も外の景色は大自然満載です。
        </p>
        <p class="room-item-p">定員<br />2名様を想定</p>
        <p class="room-item-p">料金<br>
        お一人様：16,000～</p>
        <p class="room-item-p">
          設備等<br />
          テレビ／冷蔵庫／冷暖房／床暖房／空気清浄機／お風呂／洗面台／トイレ
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import splitText from "../../plugins/textSplit";
import ScrollObserver from "../../plugins/scroll";
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload)

require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
export default {
  components: {
  },

  data() {
    return {
      images: [
        {
          thumb: require("@/assets/img/sample2/room/room-wa1.jpg"),
          src: require("@/assets/img/sample2/room/room-wa1.jpg"),
          caption: "caption1",
        },
        {
          thumb: require("@/assets/img/sample2/room/room-wa2.jpg"),
          src: require("@/assets/img/sample2/room/room-wa2.jpg"),
        },
        {
          thumb: require("@/assets/img/sample2/room/room-wa3.jpg"),
          src: require("@/assets/img/sample2/room/room-wa3.jpg"),
        },
        {
          thumb: require("@/assets/img/sample2/room/room-y1.jpg"),
          src: require("@/assets/img/sample2/room/room-y1.jpg"),
        },
        {
          thumb: require("@/assets/img/sample2/room/room-y2.jpg"),
          src: require("@/assets/img/sample2/room/room-y2.jpg"),
        },
      ],
    };
  },
  mounted() {
    splitText(".room-h2");
    ScrollObserver("small, .char");
  },
  methods: {
    showLightbox(index) {
      this.$refs.lightbox.showImage(index);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  color: white;
  text-shadow: #fc0 1px 0 5px;
  max-width: 1100px;
  margin: 0 auto;
  & .room-h2 {
    & ::v-deep .char {
      display: inline-block;
      opacity: 0;
      &.inview {
        animation: drop 2s ease forwards;
        @for $i from 1 through 5 {
          &.inview:nth-child(#{$i}) {
            animation-delay: $i * 0.08s;
          }
        }
      }
    }
  }
  & .room-h3 {
     margin-bottom: 0.8rem;
  }
  & .room-p {
    font-size: 0.9rem;
    & small {
      background: linear-gradient(transparent 90%, #ff0000 10%);
      background-repeat: no-repeat;
      background-position: bottom left;
      background-size: 0%;
      text-shadow: black 1px 0 5px;
      color: lightgray;
      transition: all 1.7s ease;
      &.inview {
        background-size: 100%;
      }
    }
  }
  & .room-item {
    margin: 20px;
    &.wa {
      background: url("/room-wa2.jpg") center center / cover no-repeat;
      & .bgimg-opc {
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        backdrop-filter: blur(2.5px);
      }
    }
    &.yo {
      background: url("/room-y1.jpg") center center / cover no-repeat;
      z-index: 2;
      & .bgimg-opc {
        z-index: 2;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        backdrop-filter: blur(2.5px);
      }
    }
    & .room-title {
      padding-top: 10px;
      text-decoration: underline 2px;
      font-weight: normal;
    }
    & .room-imgs {
      display: flex;
      justify-content: space-between;
      margin: 20px;
      & .room-img {
        width: 30%;
      }
    }
    & .room-imgs-y {
      display: flex;
      justify-content: space-evenly;
      margin: 20px;
      & .room-img-y {
        width: 40%;
      }
    }
    & .room-item-p {
      padding: 10px;
      font-size: 14px;
      margin: 0;
    }
  }
}
@keyframes drop {
  0% {
    transform: translateY(-30px);
    opacity: 0;
  }
  20% {
    transform: translateY(0px);
    opacity: 1;
    
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
    text-decoration: underline;
  }
}

@media (max-width: 600px) {
  .container {
    .room-item {
      .room-imgs,
      .room-imgs-y {
        flex-direction: column;
        margin: 0;
        & .room-img,
        .room-img-y {
          width: 100%;
        }
      }
    }
  }
}
</style>
